import { useCallback } from 'react';
import type { CalendarType } from '@lingoda/monolith-graphql';
import { goTo } from '@lingoda/router';
import { getApolloErrorUiMessage, useConnectCalendarLazyQuery } from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';
import { showErrorToast } from '@lingoda/toasts';

export const useConnectCalendar = () => {
    const [connect, { loading, error, variables }] = useConnectCalendarLazyQuery({
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });

    const connectCalendar = useCallback(
        async (type: CalendarType) => {
            const { data } = await connect({ variables: { calendarType: type } });
            if (data?.calendarAuthRedirectUrl) {
                goTo(decodeURIComponent(data.calendarAuthRedirectUrl));
            }
        },
        [connect],
    );

    return {
        connectCalendar,
        loading,
        error,
        type: variables?.calendarType,
    };
};
